<template>
  <div
    class="fixed inset-0 flex items-center justify-center bg-white opacity-60 z-50"
  >
    <div class="loader"></div>
  </div>
</template>

<style scoped>
.loader {
  width: 50px;
  height: 50px;
  border: 6px solid #e0e0e0;
  border-top-color: #40008A;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
